/**
 * config接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const configEndpoints: ApiEndpoint[] = [
  {
    id: "config-list",
    method: "GET",
    path: "/api/config",
    name: "获取配置列表",
    description: "获取系统配置列表",
    category: API_CATEGORIES.CONFIG,
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "array", description: "配置列表" },
    ],
  },
  {
    id: "config-detail",
    method: "GET",
    path: "/api/config/:key",
    name: "获取配置详情",
    description: "根据key获取配置详情",
    category: API_CATEGORIES.CONFIG,
    pathParams: [{ name: "key", type: "string", required: true, description: "配置key" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "object", description: "配置信息" },
    ],
  },
  {
    id: "config-create",
    method: "POST",
    path: "/api/config",
    name: "创建配置",
    description: "创建新的系统配置",
    category: API_CATEGORIES.CONFIG,
    bodyParams: [
      { name: "key", type: "string", required: true, description: "配置key" },
      { name: "value", type: "any", required: true, description: "配置值" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "object", description: "创建的配置" },
    ],
  },
  {
    id: "config-update",
    method: "PUT",
    path: "/api/config/:key",
    name: "更新配置",
    description: "更新系统配置",
    category: API_CATEGORIES.CONFIG,
    pathParams: [{ name: "key", type: "string", required: true, description: "配置key" }],
    bodyParams: [{ name: "value", type: "any", required: true, description: "配置值" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "object", description: "更新后的配置" },
    ],
  },
  {
    id: "config-delete",
    method: "DELETE",
    path: "/api/config/:key",
    name: "删除配置",
    description: "删除系统配置",
    category: API_CATEGORIES.CONFIG,
    pathParams: [{ name: "key", type: "string", required: true, description: "配置key" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
  },
  {
    id: "config-batch",
    method: "POST",
    path: "/api/config/batch",
    name: "批量获取配置",
    description: "根据key列表批量获取配置",
    category: API_CATEGORIES.CONFIG,
    bodyParams: [{ name: "keys", type: "array", required: true, description: "配置key数组", example: "[\"key1\", \"key2\"]" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "object", description: "配置对象（key-value）" },
    ],
  },
  {
    id: "config-permissions",
    method: "GET",
    path: "/api/config/permissions",
    name: "获取权限配置",
    description: "获取系统权限配置信息",
    category: API_CATEGORIES.CONFIG,
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data", type: "object", description: "权限配置" },
    ],
  },
];
